import { BrandedNotification } from '../enums';
const MODULE_PREFIX = BrandedNotification.BRANDED_NOTIFICATION;
export const BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA = `${MODULE_PREFIX}_GET_CONFIGURATION_DATA`;
export const BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_SUCCESS = `${MODULE_PREFIX}_GET_CONFIGURATION_SUCCESS`;
export const BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_FAILURE = `${MODULE_PREFIX}_GET_CONFIGURATION_FAILURE`;
export const getConfigurationDataAction = (brandedNotificationInputs, coCode, defaultProfileData) => ({
    type: BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA,
    payload: { brandedNotificationInputs, coCode, defaultProfileData }
});
export const getConfigurationDataSuccessAction = brandedNotificationConfigurationData => ({
    type: BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_SUCCESS,
    payload: { brandedNotificationConfigurationData }
});
export const getConfigurationDataFailureAction = failureMessage => ({
    type: BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=getConfigurationBrandedNotificationAction.js.map